export enum RiskTemplateTypes {
  overAllRisk = 'OVER_ALL_RISK',
  impactAndProbability = 'IMPACT_AND_PROBABILITY'
}
